export const backgroundColor = "#EBF1F4"
export const successColor = "#1BC961"
export const lightSuccessColor = "#DFFFEF"
export const dangerColor = "#FF4500"
export const lightDangerColor = "#FFDCD3"
export const lightTextColor = "#454D66"
export const fonts = { quicksand: "Quicksand, sans-serif" }
